import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to, from) => {
  if (to.path !== from.path) {
    console.log('scroll to top')
    window.scrollTo(0, 0)
  }

  console.log('(next) passthrough')
})
